import { render, staticRenderFns } from "./UserMoreItem.vue?vue&type=template&id=874d0b4e&scoped=true&"
import script from "./UserMoreItem.vue?vue&type=script&lang=ts&"
export * from "./UserMoreItem.vue?vue&type=script&lang=ts&"
import style0 from "./UserMoreItem.vue?vue&type=style&index=0&id=874d0b4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874d0b4e",
  null
  
)

export default component.exports